import gql from "graphql-tag";

export const M_ADD_ARTIST = gql`
  mutation($spotify_id: String!) {
    add_artist(artist_spotify_id: $spotify_id) {
      token
      user {
        id
        email
        coupon
        plan
        first_billing_date
        next_billing_date
        artists {
          id
          name
          spotify_id
          avatar_url
          username
        }
      }
    }
  }
`;

export const Q_BOT_BLOCK = gql`
  query GetBotBlock($artist_id: uuid!) {
    artists_by_pk(id: $artist_id) {
      block_bots
    }
  }
`;

export const M_UPDATE_BOT_BLOCK = gql`
  mutation UpdateBotBlock($artist_id: uuid!, $block_bots: Boolean!) {
    update_artists_by_pk(
      pk_columns: { id: $artist_id }
      _set: { block_bots: $block_bots }
    ) {
      id
    }
  }
`;

export const M_LOGIN = gql`
  mutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        billing_interval
        braintree_subscription_status
        master_account_id
        email_pending
        feature_flags {
          id
          feature
          enabled
        }
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
          phone_numbers {
            id
            phone_number
            welcome_message
            created_at
            artist_id
          }
        }
      }
    }
  }
`;

export const Q_GET_USER = gql`
  query {
    get_current_user_data {
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        billing_interval
        braintree_subscription_status
        master_account_id
        feature_flags {
          id
          feature
          enabled
        }
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
          phone_numbers {
            id
            phone_number
            welcome_message
            created_at
            artist_id
          }
        }
      }
    }
  }
`;

export const M_RESET_PASSWORD = gql`
  mutation($password: String!, $token: String!) {
    reset_password(token: $token, password: $password) {
      success
    }
  }
`;

export const M_RESET_PASSWORD_ADMIN = gql`
  mutation($email: String!, $new_password: String!, $admin_password: String!) {
    reset_password_admin(
      email: $email
      new_password: $new_password
      admin_password: $admin_password
    ) {
      success
    }
  }
`;

export const M_RESET_PASSWORD_REQUEST = gql`
  mutation($email: String!) {
    reset_password_request(email: $email) {
      success
    }
  }
`;

export const M_REGISTER = gql`
  mutation(
    $email: String!
    $password: String!
    $artist_spotify_id: String!
    $coupon: String
  ) {
    register(
      email: $email
      password: $password
      artist_spotify_id: $artist_spotify_id
      coupon: $coupon
    ) {
      token
      user {
        id
        email
        coupon
        plan
        first_billing_date
        next_billing_date
        artists {
          id
          name
          spotify_id
          avatar_url
          username
        }
      }
    }
  }
`;

export const M_REGISTER_INVITED = gql`
  mutation(
    $token: String!
    $first_name: String!
    $last_name: String!
    $password: String!
    $coupon: String!
  ) {
    register_invited(
      token: $token
      first_name: $first_name
      last_name: $last_name
      password: $password
      coupon: $coupon
    ) {
      token
      user {
        id
        email
        coupon
        plan
        master_account_id
        first_billing_date
        next_billing_date
        artists {
          id
          name
          spotify_id
          avatar_url
          username
        }
      }
    }
  }
`;

export const M_INSERT_PIXEL = gql`
  mutation($pixel: pixels_insert_input!) {
    insert_pixels_one(object: $pixel) {
      id
    }
  }
`;

export const M_UPDATE_LINK_DESTINATION_PRIORITY = gql`
  mutation($id: uuid!, $priority: Int!) {
    update_link_destinations(
      where: { id: { _eq: $id } }
      _set: { priority: $priority }
    ) {
      affected_rows
    }
  }
`;

export const M_BRAINTREE_CLIENT_TOKEN = gql`
  mutation {
    braintree_client_token {
      token
    }
  }
`;

export const M_BRAINTREE_UPDATE_PAYMENT = gql`
  mutation($braintree_nonce: String!) {
    braintree_update_payment(braintree_nonce: $braintree_nonce) {
      success
      token
    }
  }
`;

export const M_DELETE_LINK = gql`
  mutation($link_id: uuid!) {
    delete_links_by_pk(id: $link_id) {
      id
    }
  }
`;

export const M_FILL_MISSING_DEEPLINKS = gql`
  mutation($link_id: String!) {
    fill_missing_deeplinks(link_id: $link_id) {
      success
    }
  }
`;

export const M_INSERT_LINK = gql`
  mutation(
    $artist_id: uuid!
    $path: String!
    $domain: String
    $image: String!
    $title: String!
    $subtitle: String = ""
    $description: String = ""
    $preview_type: String = "image"
    $theme: String!
    $display_artist_socials: Boolean!
    $destinations: link_destinations_arr_rel_insert_input
    $tracks: link_tracks_arr_rel_insert_input
    $post_release_title: String
    $post_release_subtitle: String
    $release_name: String
    $release_time: timestamptz
    $offset: String
    $timezone: String
    $type: String
    $rid: String
    $layout: Int!
    $cover_image_style: String
  ) {
    insert_links(
      objects: {
        artist_id: $artist_id
        path: $path
        domain: $domain
        image: $image
        title: $title
        subtitle: $subtitle
        preview_type: $preview_type
        description: $description
        theme: $theme
        display_artist_socials: $display_artist_socials
        destinations: $destinations
        tracks: $tracks
        post_release_title: $post_release_title
        post_release_subtitle: $post_release_subtitle
        release_name: $release_name
        release_time: $release_time
        offset: $offset
        timezone: $timezone
        type: $type
        rid: $rid
        layout: $layout
        cover_image_style: $cover_image_style
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const M_PATH_AVAILABLE = gql`
  mutation($domain: String!, $path: String!) {
    path_available(domain: $domain, path: $path) {
      success
    }
  }
`;

export const M_UPDATE_LINK = gql`
  mutation(
    $id: uuid!
    $title: String!
    $image: String!
    $subtitle: String
    $domain: String
    $path: String
    $description: String
    $preview_type: String
    $theme: String!
    $display_artist_socials: Boolean!
    $post_release_title: String
    $post_release_subtitle: String
    $release_name: String
    $release_time: timestamptz
    $offset: String
    $timezone: String
    $layout: Int!
    $cover_image_style: String
    $rid: String
  ) {
    update_links_by_pk(
      pk_columns: { id: $id }
      _set: {
        title: $title
        image: $image
        domain: $domain
        path: $path
        subtitle: $subtitle
        description: $description
        preview_type: $preview_type
        theme: $theme
        display_artist_socials: $display_artist_socials
        post_release_title: $post_release_title
        post_release_subtitle: $post_release_subtitle
        release_name: $release_name
        release_time: $release_time
        offset: $offset
        timezone: $timezone
        layout: $layout
        cover_image_style: $cover_image_style
        rid: $rid
      }
    ) {
      id
    }
  }
`;

export const M_UPDATE_LINK_DESTINATION = gql`
  mutation(
    $id: uuid!
    $url: String
    $cta: String
    $type: String!
    $text: String
    $logo: String
    $enabled: Boolean
    $deeplink_ios: String
    $deeplink_android: String
    $description: String
    $autoplay_track: String
    $pre_release: Boolean
    $config: jsonb
    $redirect_url: String
    $priority: Int
  ) {
    update_link_destinations_by_pk(
      pk_columns: { id: $id }
      _set: {
        url: $url
        cta: $cta
        type: $type
        text: $text
        logo: $logo
        enabled: $enabled
        deeplink_ios: $deeplink_ios
        deeplink_android: $deeplink_android
        description: $description
        autoplay_track: $autoplay_track
        pre_release: $pre_release
        config: $config
        redirect_url: $redirect_url
        priority: $priority
      }
    ) {
      id
    }
  }
`;

export const M_INSERT_BULK_MESSAGES = gql`
  mutation($bulk_messages: [bulk_messages_insert_input!]!) {
    insert_bulk_messages(
      objects: $bulk_messages
      on_conflict: {
        constraint: bulk_messages_destination_id_key
        update_columns: [message]
      }
    ) {
      affected_rows
    }
  }
`;

// TODO: Can this just be part of link upsert?
export const M_INSERT_LINK_DESTINATION = gql`
  mutation(
    $link_id: uuid!
    $type: String!
    $cta: String!
    $url: String
    $text: String
    $logo: String
    $enabled: Boolean
    $deeplink_ios: String
    $deeplink_android: String
    $description: String
    $autoplay_track: String
    $pre_release: Boolean
    $config: jsonb
    $redirect_url: String
    $priority: Int
    $presave_jobs: String
    $bulk_messages: bulk_messages_arr_rel_insert_input
  ) {
    insert_link_destinations(
      objects: {
        link_id: $link_id
        type: $type
        cta: $cta
        url: $url
        text: $text
        logo: $logo
        enabled: $enabled
        deeplink_ios: $deeplink_ios
        deeplink_android: $deeplink_android
        description: $description
        autoplay_track: $autoplay_track
        pre_release: $pre_release
        config: $config
        redirect_url: $redirect_url
        priority: $priority
        presave_jobs: $presave_jobs
        bulk_messages: $bulk_messages
      }
    ) {
      affected_rows
    }
  }
`;

export const M_DELETE_LINK_DESTINATION = gql`
  mutation($id: uuid!) {
    delete_link_destinations_by_pk(id: $id) {
      id
    }
  }
`;

export const Q_LINKS = gql`
  query($artist_id: uuid!) {
    links(
      where: { artist_id: { _eq: $artist_id } }
      order_by: { created_at: asc }
    ) {
      id
      created_at
      image
      domain
      path
      title
      type
      subtitle
      description
      theme
      views: views_total
      clickthroughs: clickthroughs_total
      rid
      release_name
    }
  }
`;

export const Q_META = gql`
  query($url: String!) {
    meta(url: $url) {
      data
    }
  }
`;

export const Q_GET_LONGER_URL = gql`
  query($link: String!) {
    get_long_spotify_url_from_shortened(link: $link) {
      preview_url
    }
  }
`;

export const M_RID_FROM_LINK = gql`
  mutation($link: String!) {
    rid_from_link(link: $link) {
      success
      rid
      type
    }
  }
`;

export const M_LINKS_FROM_RID = gql`
  mutation($rid: String!, $type: String!) {
    links_from_rid(rid: $rid, type: $type) {
      success
      links {
        url
        platform
      }
    }
  }
`;

export const Q_PIXELS = gql`
  query($payload: pixels_bool_exp!) {
    pixels(where: $payload) {
      id
      provider
      pixel
      access_token
      artist_id
      agency_id
    }
  }
`;

export const Q_LINK_PIXELS = gql`
  query($link_id: uuid!) {
    pixels(where: { link_id: { _eq: $link_id } }) {
      id
      provider
      pixel
      access_token
      link_id
    }
  }
`;

export const M_DELETE_PIXEL = gql`
  mutation($id: uuid!) {
    delete_pixels_by_pk(id: $id) {
      id
    }
  }
`;

export const S_LINK = gql`
  query($link_id: uuid!) {
    links_by_pk(id: $link_id) {
      id
      created_at
      image
      domain
      path
      type
      title
      subtitle
      description
      preview_type
      theme
      display_artist_socials
      release_time
      offset
      timezone
      post_release_title
      post_release_subtitle
      rid
      layout
      cover_image_style
      release_name
      tracks {
        id
        name
        url
      }
      artist {
        presave_subscriptions(
          where: {
            _or: [
              { link_id: { _is_null: true } }
              { link_id: { _eq: $link_id } }
            ]
          }
          distinct_on: presave_token_id
          order_by: [{ presave_token_id: asc }, { link_id: asc_nulls_last }]
        ) {
          id
          link_id
          presave_token {
            provider
          }
        }
      }
    }
  }
`;

export const Q_LINK_EDIT_PRESERVE = gql`
  query($link_id: uuid!) {
    links_by_pk(id: $link_id) {
      id
      rid
      destinations(where: { pre_release: { _eq: false } }) {
        id
        type
        presave_jobs
      }
    }
  }
`;

export const Q_LINK_DESTINATIONS = gql`
  query($link_id: uuid!) {
    link_destinations(where: { link_id: { _eq: $link_id } }) {
      id
      short_id
      logo
      type
      url
      deeplink_ios
      deeplink_android
      text
      cta
      clickthroughs: clickthroughs_total
      priority
      enabled
      deeplink_ios
      deeplink_android
      description
      autoplay_track
      pre_release
      config
      redirect_url
      presaves_aggregate {
        aggregate {
          count
        }
      }
      optins_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const S_STATS_TODAY = gql`
  subscription($artist_id: uuid!) {
    stats_artist_daily(
      where: {
        reporting_date: { _eq: "now()" }
        artist_id: { _eq: $artist_id }
      }
    ) {
      views
      fans
    }
  }
`;

export const S_STATS_DAILY = gql`
  subscription($artist_id: uuid!) {
    stats_artist_daily(where: { artist_id: { _eq: $artist_id } }, offset: 22) {
      reporting_date
      views
      fans
    }
  }
`;

export const S_STATS_LINK = gql`
  subscription($link_id: uuid!) {
    stats_link_daily(where: { link_id: { _eq: $link_id } }) {
      reporting_date
      views
      fans
    }
  }
`;

export const S_ARTISTS = gql`
  subscription($user_id: uuid!) {
    artists(
      order_by: { name: asc }
      where: { users: { user_id: { _eq: $user_id } } }
    ) {
      id
      name
      spotify_id
      avatar_url
      username
      billing_user_id
      plan
      first_billing_date
      next_billing_date
      monthly_charge
      braintree_subscription_status
      braintree_subscription_id
      current_plan
      active_plan
    }
  }
`;

export const Q_LINK_TOTALS = gql`
  query($artist_id: String!) {
    link_totals(artist_id: $artist_id) {
      data
    }
  }
`;

export const Q_LINK_EVENTS_DAILY = gql`
  query(
    $link_id: uuid
    $start_date: date
    $end_date: date
    $timezone: String
    $event: String
  ) {
    link_events_daily(
      args: {
        link_id: $link_id
        start_date: $start_date
        end_date: $end_date
        timezone: $timezone
        event: $event
      }
    ) {
      day
      count: count1
      fans: count2
    }
  }
`;

export const Q_LINK_EVENTS_COUNTRY = gql`
  query($link_id: uuid, $start_date: date, $end_date: date, $timezone: String) {
    link_events_country(
      args: {
        link_id: $link_id
        start_date: $start_date
        end_date: $end_date
        timezone: $timezone
      }
    ) {
      name
      count
    }
  }
`;

export const Q_LINK_EVENTS_REFERRER = gql`
  query($link_id: uuid, $start_date: date, $end_date: date, $timezone: String) {
    link_events_referrer(
      args: {
        link_id: $link_id
        start_date: $start_date
        end_date: $end_date
        timezone: $timezone
      }
    ) {
      name
      count
    }
  }
`;

export const Q_LINK_EVENTS_UTM_MEDIUM = gql`
  query($link_id: uuid, $start_date: date, $end_date: date, $timezone: String) {
    link_events_utm_medium(
      args: {
        link_id: $link_id
        start_date: $start_date
        end_date: $end_date
        timezone: $timezone
      }
    ) {
      name
      count
    }
  }
`;

export const Q_LINK_EVENTS_UTM_SOURCE = gql`
  query($link_id: uuid, $start_date: date, $end_date: date, $timezone: String) {
    link_events_utm_source(
      args: {
        link_id: $link_id
        start_date: $start_date
        end_date: $end_date
        timezone: $timezone
      }
    ) {
      name
      count
    }
  }
`;

export const Q_LINK_EVENTS_UTM_CAMPAIGN = gql`
  query($link_id: uuid, $start_date: date, $end_date: date, $timezone: String) {
    link_events_utm_campaign(
      args: {
        link_id: $link_id
        start_date: $start_date
        end_date: $end_date
        timezone: $timezone
      }
    ) {
      name
      count
    }
  }
`;

export const Q_USERS = gql`
  query($email: String!) {
    users(where: { email: { _eq: $email } }) {
      id
    }
  }
`;

export const Q_ARTIST_USERS = gql`
  query($artist_id: uuid!) {
    artist_users(where: { artist_id: { _eq: $artist_id } }) {
      artist_id
      user_id
      role
      id
      team_user {
        user_id
        email
      }
      user {
        id
        email
        invitation_pending
        invitation
      }
    }
  }
`;

export const M_INVITE_USER = gql`
  mutation($email: String!, $artist_id: String!, $coupon: String!) {
    invite_user(email: $email, artist_id: $artist_id, coupon: $coupon) {
      success
    }
  }
`;

export const M_INSERT_ARTIST_USER = gql`
  mutation($artist_user: artist_users_insert_input!) {
    insert_artist_users_one(object: $artist_user) {
      id
    }
  }
`;

export const M_DELETE_ARTIST_USER = gql`
  mutation($artist_users_id: uuid!) {
    delete_artist_users_by_pk(id: $artist_users_id) {
      id
    }
  }
`;

export const Q_ARTIST_DOMAINS = gql`
  query($artist_id: uuid!) {
    domains(where: { artist_id: { _eq: $artist_id } }) {
      id
      domain
      verification_facebook
    }
  }
`;

export const M_INSERT_ARTIST_DOMAIN = gql`
  mutation($artist_id: uuid!, $domain: String!) {
    insert_domains_one(object: { artist_id: $artist_id, domain: $domain }) {
      id
    }
  }
`;

export const M_UPDATE_DOMAINS_BY_PK = gql`
  mutation($id: uuid!, $verification_facebook: String!) {
    update_domains_by_pk(
      pk_columns: { id: $id }
      _set: { verification_facebook: $verification_facebook }
    ) {
      id
    }
  }
`;

export const M_ADD_CUSTOM_DOMAIN = gql`
  mutation($domain: String!) {
    add_custom_domain(domain: $domain) {
      id
      domain
      user_id
    }
  }
`;

export const M_INSERT_CUSTOM_DOMAIN = gql`
  mutation($user_id: uuid!, $domain: String!) {
    insert_custom_domains_one(object: { user_id: $user_id, domain: $domain }) {
      id
      domain
      user_id
    }
  }
`;

export const Q_CUSTOM_DOMAINS = gql`
  query($user_id: uuid!) {
    custom_domains(where: { user_id: { _eq: $user_id } }) {
      id
      domain
      user_id
      custom_domain_artists {
        artist_id
        custom_domain_id
        id
      }
    }
  }
`;

export const M_DELETE_CUSTOM_DOMAIN = gql`
  mutation($domain_id: String!) {
    remove_custom_domain(id: $domain_id) {
      id
    }
  }
`;

export const Q_CUSTOM_DOMAIN_ARTISTS = gql`
  query($user_id: uuid!) {
    custom_domains(where: { user_id: { _eq: $user_id } }) {
      id
      domain
      user_id
    }
  }
`;

export const Q_CUSTOM_DOMAIN_ARTISTS_BY_ARTIST = gql`
  query($artist_id: uuid!) {
    custom_domain_artists(where: { artist_id: { _eq: $artist_id } }) {
      custom_domain {
        domain
      }
    }
  }
`;

export const M_INSERT_CUSTOM_DOMAIN_ARTISTS = gql`
  mutation($artist_id: uuid!, $custom_domain_id: uuid!) {
    insert_custom_domain_artists_one(
      object: { artist_id: $artist_id, custom_domain_id: $custom_domain_id }
    ) {
      artist_id
      custom_domain_id
      id
    }
  }
`;

export const M_DELETE_CUSTOM_DOMAIN_ARTIST = gql`
  mutation($custom_domain_id: uuid!, $artist_id: uuid!) {
    delete_custom_domain_artists(
      where: {
        custom_domain_id: { _eq: $custom_domain_id }
        artist_id: { _eq: $artist_id }
      }
    ) {
      affected_rows
    }
  }
`;

export const Q_ARTIST_SOCIALS = gql`
  query($artist_id: uuid!) {
    artist_socials(where: { artist_id: { _eq: $artist_id } }) {
      artist_id
      created_at
      id
      type
      url
    }
  }
`;

export const Q_SEARCH_ARTISTS = gql`
  query($name: String!) {
    search_artists(name: $name) {
      data
    }
  }
`;

export const M_INSERT_ARTIST_SOCIALS = gql`
  mutation($objects: [socials_insert_input!]!) {
    insert_artist_socials(objects: $objects) {
      returning {
        name
      }
    }
  }
`;

export const M_UPDATE_ARTIST_SOCIAL_BY_PK = gql`
  mutation($id: uuid!, $url: String!) {
    update_artist_socials_by_pk(pk_columns: { id: $id }, _set: { url: $url }) {
      id
    }
  }
`;

export const M_DELETE_ARTIST_SOCIALS = gql`
  mutation($artist_social_ids: [uuid!]!) {
    delete_artist_socials(where: { id: { _in: $artist_social_ids } }) {
      id
    }
  }
`;

export const M_UPDATE_ARTIST_SOCIALS = gql`
  mutation(
    $new_artist_socials: [artist_socials_insert_input!]!
    $deleted_artist_social_ids: [uuid!]!
  ) {
    insert_artist_socials(objects: $new_artist_socials) {
      affected_rows
    }
    delete_artist_socials(where: { id: { _in: $deleted_artist_social_ids } }) {
      affected_rows
    }
  }
`;

export const S3_UPLOAD = gql`
  mutation($extension: String!, $type: String!) {
    s3_upload(extension: $extension, type: $type) {
      key
      url
    }
  }
`;

export const M_CHECK_SIGNUP_STEP = gql`
  mutation($email: String!, $coupon: String) {
    signup_check_step(email: $email, coupon: $coupon) {
      signup_finished
      email_pending
      signup_step
    }
  }
`;

export const Q_CHECK_INVITATION = gql`
  mutation($token: String!) {
    register_invitation_check(token: $token) {
      status
    }
  }
`;

export const Q_CHECK_EMAIL_TOKEN = gql`
  query($email: String!, $email_token: String!) {
    check_email_token(email: $email, email_token: $email_token) {
      success
    }
  }
`;

export const M_SET_PASSWORD_SIGNUP = gql`
  mutation($email: String!, $password: String!) {
    set_password_signup(email: $email, password: $password) {
      token
      user {
        id
      }
    }
  }
`;

export const M_UPDATE_SIGNUP_STEP = gql`
  mutation($id: String!, $signup_step: Int!) {
    set_signup_step(id: $id, signup_step: $signup_step) {
      success
    }
  }
`;

export const M_UPDATE_NAME = gql`
  mutation($id: uuid, $first_name: String, $last_name: String) {
    update_users(
      where: { id: { _eq: $id } }
      _set: { first_name: $first_name, last_name: $last_name }
    ) {
      affected_rows
    }
  }
`;

export const Q_ITUNES_AFFILIATE_ID = gql`
  query($id: uuid!) {
    user: users_by_pk(id: $id) {
      itunes_affiliate_id
    }
  }
`;

export const M_UPDATE_ITUNES_AFFILIATE_ID = gql`
  mutation($id: uuid, $itunes_affiliate_id: String) {
    update_users(
      where: { id: { _eq: $id } }
      _set: { itunes_affiliate_id: $itunes_affiliate_id }
    ) {
      affected_rows
    }
  }
`;

export const M_UPDATE_WHERES_MUSIC = gql`
  mutation($id: uuid, $wheres_music: String!) {
    update_users(
      where: { id: { _eq: $id } }
      _set: { wheres_music: $wheres_music }
    ) {
      affected_rows
    }
  }
`;

export const M_ADD_ARTISTS = gql`
  mutation($spotify_id: String!) {
    add_artists(artist_spotify_id: $spotify_id) {
      token
      user {
        id
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          billing_user_id
        }
      }
    }
  }
`;

export const M_REMOVE_SIGNUP_ARTIST = gql`
  mutation($artist_id: String!) {
    remove_signup_artist(artist_id: $artist_id) {
      success
    }
  }
`;

export const Q_CHECK_DISCOUNT_COUPON = gql`
  query($coupon: String!) {
    check_discount_coupon(coupon: $coupon) {
      success
      coupon {
        name
        free_months
        prepend
        amount
      }
    }
  }
`;

export const M_UPSERT_PIXELS = gql`
  mutation($pixels: [pixels_insert_input!]!) {
    insert_pixels(
      objects: $pixels
      on_conflict: {
        constraint: pixels_artist_id_provider_key
        update_columns: [pixel, access_token]
      }
    ) {
      returning {
        provider
        pixel
        id
        artist_id
        access_token
      }
    }
  }
`;

export const M_UPDATE_SIGNUP_FINISHED = gql`
  mutation($id: uuid, $signup_finished: Boolean) {
    update_users(
      where: { id: { _eq: $id } }
      _set: { signup_finished: $signup_finished }
    ) {
      affected_rows
    }
  }
`;

export const M_UPDATE_EMAIL_REQUEST = gql`
  mutation($email: String!) {
    update_email_request(email: $email) {
      success
    }
  }
`;

export const M_UPDATE_EMAIL = gql`
  mutation($email: String!, $email_token: String!) {
    update_email(email: $email, email_token: $email_token) {
      success
    }
  }
`;

export const M_UPDATE_PASSWORD = gql`
  mutation(
    $current_password: String!
    $new_password: String!
    $user_id: String!
  ) {
    update_password(
      current_password: $current_password
      new_password: $new_password
      user_id: $user_id
    ) {
      success
    }
  }
`;

export const Q_BILLING_TRANSACTIONS_BY_ARTIST = gql`
  query($artist_id: uuid!) {
    transactions(where: { artist_id: { _eq: $artist_id } }) {
      id
      amount
      artist_id
      billing_user_id
      braintree_customer_id
      braintree_plan_id
      braintree_subscription_id
      braintree_transaction_id
      card_type
      image_url
      last4
      created_at
    }
  }
`;

export const Q_BILLING_TRANSACTIONS_BY_USER = gql`
  query($billing_user_id: uuid!) {
    transactions(where: { billing_user_id: { _eq: $billing_user_id } }) {
      id
      amount
      artist_id
      billing_user_id
      braintree_customer_id
      braintree_plan_id
      braintree_subscription_id
      braintree_transaction_id
      card_type
      image_url
      last4
      created_at
      artist {
        name
        avatar_url
      }
    }
  }
`;

export const M_ADD_AGENCY_ARTISTS = gql`
  mutation($artists: [SubscriptionArtistInput!]!) {
    braintree_add_agency_artists(artists: $artists) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_ADD_INITIAL_ARTISTS = gql`
  mutation(
    $email: String!
    $artists: [SubscriptionArtistInput!]!
    $coupon: String
  ) {
    braintree_add_initial_artists(
      email: $email
      artists: $artists
      coupon: $coupon
    ) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_ADD_FAMILY_ARTISTS = gql`
  mutation($artists: [SubscriptionArtistInput!]!) {
    braintree_add_family_artists(artists: $artists) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_CANCEL_ARTIST_SUBSCRIPTION = gql`
  mutation($artist_id: String!) {
    braintree_cancel_artist_subscription(artist_id: $artist_id) {
      success
    }
  }
`;

export const M_CANCEL_USER_SUBSCRIPTION = gql`
  mutation($subscription_id: String!) {
    braintree_cancel_user_subscription(subscription_id: $subscription_id) {
      success
    }
  }
`;

export const M_CHANGE_ARTIST_SUBSCRIPTION = gql`
  mutation($artist_id: String!, $braintree_nonce: String!, $plan: String!) {
    braintree_change_subscription(
      artist_id: $artist_id
      braintree_nonce: $braintree_nonce
      plan: $plan
    ) {
      success
    }
  }
`;

export const M_REACTIVATE_ARTIST_SUBSCRIPTION = gql`
  mutation($artist_id: String!, $braintree_nonce: String!) {
    braintree_reactivate_artist_subscription(
      artist_id: $artist_id
      braintree_nonce: $braintree_nonce
    ) {
      success
    }
  }
`;

export const Q_USER = gql`
  query($id: uuid!) {
    users_by_pk(id: $id) {
      id
      artists {
        id
        name
        spotify_id
        avatar_url
        username
        plan
        billing_user_id
        braintree_subscription_status
        braintree_subscription_id
        first_billing_date
        next_billing_date
        monthly_charge
      }
    }
  }
`;

export const Q_USER_COUPON = gql`
  query($user_id: uuid!) {
    discount_coupons(where: { user_id: { _eq: $user_id } }) {
      id
      name
      coupon
    }
  }
`;

export const M_CREATE_COUPON = gql`
  mutation($coupon: String!) {
    insert_discount_coupons_one(
      object: { coupon: $coupon, name: $coupon } # on_conflict: { #   constraint: discount_coupons_user_id_key #   update_columns: [coupon, name] # }
    ) {
      id
    }
  }
`;

export const Q_REFERRALS_DATA = gql`
  query {
    get_referrals_data {
      count_active
      count_pending
      payout
      payout_date
    }
  }
`;

export const Q_AFFILIATE_PAYOUTS = gql`
  query {
    affiliate_payouts {
      date
      active_users
      sales
      payout
    }
  }
`;

export const Q_STATS = gql`
  query(
    $link_id: uuid!
    $start_time: date!
    $end_time: date!
    $offset: String
    $referrer: String
    $utm_campaign: String
    $utm_source: String
    $utm_medium: String
    $country: String
  ) {
    link_statistics(
      link_id: $link_id
      start_time: $start_time
      end_time: $end_time
      offset: $offset
      referrer: $referrer
      utm_campaign: $utm_campaign
      utm_source: $utm_source
      utm_medium: $utm_medium
      country: $country
    ) {
      events
      countries
      campaigns
      destinations
      platform_stats
    }
  }
`;

export const Q_STATS_ARTIST = gql`
  query(
    $artist_id: uuid!
    $start_time: date!
    $end_time: date!
    $offset: String
  ) {
    artist_statistics(
      artist_id: $artist_id
      start_time: $start_time
      end_time: $end_time
      offset: $offset
    ) {
      events
    }
  }
`;

export const M_BRAINTREE_UPDATE_ARTIST_PAYMENT = gql`
  mutation($artist_id: String!, $braintree_nonce: String!) {
    braintree_update_artist_payment(
      artist_id: $artist_id
      braintree_nonce: $braintree_nonce
    ) {
      success
      token
    }
  }
`;

export const M_BRAINTREE_UPDATE_USER_PAYMENT = gql`
  mutation($braintree_nonce: String!) {
    braintree_update_user_payment(braintree_nonce: $braintree_nonce) {
      success
      token
    }
  }
`;

export const M_ACTIVATE_COUPON = gql`
  mutation($coupon: String!) {
    activate_coupon(coupon: $coupon) {
      success
    }
  }
`;

export const Q_GET_SPOTIFY_PREVIEW_URL = gql`
  query($link: String) {
    get_spotify_preview_url(link: $link) {
      preview_url
    }
  }
`;

export const M_UPDATE_LINK_TRACK_BY_PK = gql`
  mutation($id: uuid!, $name: String, $priority: Int, $url: String) {
    update_link_tracks_by_pk(
      pk_columns: { id: $id }
      _set: { name: $name, priority: $priority, url: $url }
    ) {
      id
      link_id
      name
      priority
      url
    }
  }
`;

export const M_ADD_LINK_TRACK = gql`
  mutation($link_id: uuid, $name: String, $priority: Int, $url: String) {
    insert_link_tracks_one(
      object: { link_id: $link_id, name: $name, priority: $priority, url: $url }
    ) {
      url
      name
      id
      link_id
      priority
    }
  }
`;

export const M_DELETE_LINK_TRACK = gql`
  mutation($id: uuid!) {
    delete_link_tracks_by_pk(id: $id) {
      id
    }
  }
`;

export const Q_GET_TRANSACTIONS = gql`
  query {
    braintree_get_transactions {
      transactions
    }
  }
`;

export const Q_USER_BY_EMAIL = gql`
  query UserByEmail($email: String!) {
    user_by_email(email: $email) {
      id
    }
  }
`;

export const Q_FANS = gql`
  query fans($artist_id: uuid!) {
    optins_message: optins(
      distinct_on: [value, platform]
      where: {
        _and: [
          { artist_id: { _eq: $artist_id } }
          { link_id: { _is_null: true } }
        ]
      }
    ) {
      id
      channel: platform
      type
      contact: value
      country
      region
      city
      created_at
      source_link {
        id
        domain
        path
        title
      }
    }
    presave_subscriptions(
      distinct_on: presave_token_id
      where: {
        _and: [
          { artist_id: { _eq: $artist_id } }
          { link_id: { _is_null: true } }
        ]
      }
    ) {
      id
      presave_token {
        provider
      }
      country
      region
      city
      created_at
    }
  }
`;

export const Q_SUBSCRIBERS_COUNT = gql`
  query($artist_id: uuid!) {
    subscribers_us_canada: optins_aggregate(
      where: {
        _and: [{ artist_id: { _eq: $artist_id } }, { value: { _ilike: "+1%" } }]
      }
      distinct_on: value
    ) {
      aggregate {
        count
      }
    }
    subscribers_world: optins_aggregate(
      where: {
        _and: [
          { artist_id: { _eq: $artist_id } }
          { value: { _nilike: "%@%" } }
        ]
      }
      distinct_on: value
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const M_SCHEDULE_MESSAGE = gql`
  mutation(
    $artist_id: uuid!
    $location: String!
    $message: String!
    $send_at: timestamptz
    $sms_link: String
    $timezone: String
  ) {
    insert_bulk_messages_one(
      object: {
        artist_id: $artist_id
        location: $location
        message: $message
        send_at: $send_at
        sms_link: $sms_link
        timezone: $timezone
      }
    ) {
      id
    }
  }
`;

export const Q_SCHEDULED_MESSAGES = gql`
  query($artist_id: uuid!, $now: timestamptz!) {
    bulk_messages(
      where: {
        _and: [
          { artist_id: { _eq: $artist_id } }
          {
            _or: [
              { send_at: { _gt: $now } }
              { link_destination: { link: { release_time: { _gt: $now } } } }
            ]
          }
        ]
      }
      order_by: { send_at: desc }
    ) {
      id
      message
      send_at
      timezone
      location
      sms_link
      link_destination {
        link {
          release_time
        }
      }
    }
  }
`;

export const M_UPDATE_SCHEDULED_MESSAGE = gql`
  mutation(
    $id: uuid!
    $location: String!
    $message: String!
    $send_at: timestamptz
    $timezone: String
    $sms_link: String
  ) {
    update_bulk_messages_by_pk(
      pk_columns: { id: $id }
      _set: {
        location: $location
        message: $message
        send_at: $send_at
        timezone: $timezone
        sms_link: $sms_link
      }
    ) {
      id
    }
  }
`;

export const M_DELETE_SCHEDULED_MESSAGE = gql`
  mutation($id: uuid!) {
    delete_bulk_messages_by_pk(id: $id) {
      id
    }
  }
`;

export const Q_SENT_MESSAGES = gql`
  query($artist_id: uuid!, $now: timestamptz!) {
    bulk_messages(
      where: {
        _and: [
          { artist_id: { _eq: $artist_id } }
          {
            _or: [
              { send_at: { _lt: $now } }
              { link_destination: { link: { release_time: { _lt: $now } } } }
            ]
          }
        ]
      }
      order_by: { send_at: desc }
    ) {
      id
      message
      send_at
      location
      recipient_count
      cost
      sms_link
      link_destination {
        link {
          release_time
        }
      }
      optouts: optouts_aggregate {
        aggregate {
          count
        }
      }
      replies: optin_jobs_aggregate(where: { incoming: { _eq: true } }) {
        aggregate {
          count
        }
      }
    }
  }
`;

export const Q_BILLING_INFORMATION = gql`
  query {
    billing_information: braintree_get_billing_information {
      status
      next_billing_date
      last_billing_date
      total
      billing_interval
      add_ons {
        pro {
          quantity
          amount
        }
        bio {
          quantity
          amount
        }
        max {
          quantity
          amount
        }
      }
      artists {
        id
        name
        avatar_url
        current_plan
        active_plan
      }
      total_discount
      discount
      payment_method_available
    }
  }
`;

export const M_BRAINTREE_CHANGE_BILLING_INTERVAL = gql`
  mutation($yearly_plan: Boolean!) {
    braintree_change_billing_interval(yearly_plan: $yearly_plan) {
      success
    }
  }
`;

export const M_BRAINTREE_CHANGE_ARTIST_PLAN = gql`
  mutation($artist_id: String!, $selected_plan: String!) {
    braintree_change_artist_plan(
      artist_id: $artist_id
      selected_plan: $selected_plan
    ) {
      success
    }
  }
`;

export const M_TRIAL_CHANGE_ARTIST_PLAN_TO_ANY = gql`
  mutation($artist_id: String!, $selected_plan: String!) {
    upgrade_artist_trial_plan_to_any(
      artist_id: $artist_id
      selected_plan: $selected_plan
    ) {
      success
    }
  }
`;

export const M_BRAINTREE_ADD_ARTISTS = gql`
  mutation($artists: [SubscriptionArtistInput!]!, $coupon: String) {
    braintree_add_artists(artists: $artists, coupon: $coupon) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        billing_interval
        braintree_subscription_status
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_BRAINTREE_SUBSCRIBE = gql`
  mutation(
    $artists: [SubscriptionArtistInput!]
    $braintree_nonce: String!
    $yearly_plan: Boolean!
    $coupon: String
  ) {
    braintree_subscribe(
      braintree_nonce: $braintree_nonce
      artists: $artists
      yearly_plan: $yearly_plan
      coupon: $coupon
    ) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        billing_interval
        braintree_subscription_status
        feature_flags {
          id
          feature
          enabled
        }
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_BRAINTREE_RESUBSCRIBE = gql`
  mutation($braintree_nonce: String!) {
    braintree_resubscribe(braintree_nonce: $braintree_nonce) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        billing_interval
        braintree_subscription_status
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_BRAINTREE_RETRY_CHARGE = gql`
  mutation($braintree_nonce: String!) {
    braintree_retry_charge(braintree_nonce: $braintree_nonce) {
      token
      user {
        id
        email
        first_name
        last_name
        coupon
        plan
        first_billing_date
        next_billing_date
        signup_finished
        signup_step
        billing_interval
        braintree_subscription_status
        artists {
          id
          name
          spotify_id
          avatar_url
          username
          plan
          billing_user_id
          braintree_subscription_status
          braintree_subscription_id
          first_billing_date
          next_billing_date
          monthly_charge
          current_plan
          active_plan
        }
      }
    }
  }
`;

export const M_BRAINTREE_SET_DEFAULT_PAYMENT_METHOD = gql`
  mutation($braintree_nonce: String!) {
    braintree_set_default_payment_method(braintree_nonce: $braintree_nonce) {
      success
      token
    }
  }
`;

export const S_BILLING_USER = gql`
  subscription($artist_id: uuid!) {
    users(where: { subscription_artists: { id: { _eq: $artist_id } } }) {
      id
      braintree_subscription_status
      first_billing_date
      next_billing_date
      plan
      email
      first_name
      last_name
      monthly_charge
      yearly_charge
      feature_flags {
        id
        enabled
        feature
      }
    }
  }
`;

export const M_UPDATE_AGENCY_ARTIST_PLAN = gql`
  mutation($artist_id: String!, $plan: String!) {
    braintree_change_agency_artist_plan(
      artist_id: $artist_id
      selected_plan: $plan
    ) {
      success
    }
  }
`;

export const Q_ARTIST_SUBSCRIPTION_STATUS = gql`
  query($artist_id: uuid!) {
    artists_by_pk(id: $artist_id) {
      id
      avatar_url
      current_plan
      billing_user {
        id
        plan
      }
    }
  }
`;

export const GET_POST_BY_SLUG = gql`
  query GetPostBySlug($slug: String!) {
    blog_posts(where: { slug: { _eq: $slug } }) {
      title
      description
      content
      created_at
      category {
        id
        name
        slug
      }
    }
  }
`;

export const Q_PRO_PRICING = gql`
  query($user_id: uuid!) {
    users_by_pk(id: $user_id) {
      pro_pricing
    }
  }
`;

export const GET_POSTS = gql`
  query GetPosts($filters: blog_posts_bool_exp) {
    blog_posts(where: $filters, order_by: { created_at: desc }) {
      id
      title
      slug
      description
      created_at
      category {
        id
        name
        slug
      }
    }
  }
`;

export const GET_CATEGORIES = gql`
  query GetCategories {
    blog_categories {
      id
      name
      slug
    }
  }
`;

export const SEARCH_POSTS = gql`
  query SearchPosts($search: String!) {
    blog_posts(
      where: {
        _or: [
          { title: { _ilike: $search } }
          { description: { _ilike: $search } }
          { content: { _ilike: $search } }
        ]
      }
    ) {
      id
      title
      slug
      description
      created_at
      category {
        id
        name
        slug
      }
    }
  }
`;

export const M_UPGRADE_ARTIST_TRIAL_PLAN = gql`
  mutation($artist_id: String!) {
    upgrade_artist_trial_plan(artist_id: $artist_id) {
      success
    }
  }
`;

export const Q_GET_PHONE_NUMBERS_BY_ARTIST = gql`
  query GetPhoneNumbersByArtist($artist_id: uuid!) {
    phone_numbers(where: { artist_id: { _eq: $artist_id } }) {
      id
      phone_number
      welcome_message
      created_at
    }
  }
`;

export const M_VERIFY_EMAIL = gql`
  mutation($email: String!, $email_token: String!) {
    verify_email(email: $email, email_token: $email_token) {
      success
    }
  }
`;

export const Q_GET_ARTIST_RELEASES = gql`
  query GetArtistReleases($artist_id: String!) {
    get_artist_releases(artist_id: $artist_id) {
      success
      releases {
        id
        url
        cover_image
        name
        album_name
        release_date
        type
      }
    }
  }
`;

export const Q_QUICK_CREATE_LINK = gql`
  mutation QuickCreateLink($source: String!, $domain: String!, $path: String) {
    quick_create_link(source: $source, domain: $domain, path: $path) {
      success
      token
      link_id
      artist_id
    }
  }
`;

export const Q_DROP_SETTINGS = gql`
  query($artist_id: uuid!) {
    drop_settings: artists_by_pk(id: $artist_id) {
      emails_enabled
      sms_enabled
    }
  }
`;

export const M_UPDATE_DROP_SETTINGS = gql`
  mutation($artist_id: uuid!, $emails_enabled: Boolean, $sms_enabled: Boolean) {
    update_artists(
      where: { id: { _eq: $artist_id } }
      _set: { emails_enabled: $emails_enabled, sms_enabled: $sms_enabled }
    ) {
      affected_rows
    }
  }
`;

export const M_DELETE_ARTIST = gql`
  mutation($artist_id: String!) {
    delete_artist(artist_id: $artist_id) {
      success
    }
  }
`;

export const Q_AGENCY_MEMBERS = gql`
  query GetAgencyMembers($userId: uuid!) {
    users_by_pk(id: $userId) {
      agency_members {
        id
        email
        first_name
        last_name
      }
    }
  }
`;

export const Q_ELIGIBLE_AGENCY_CANDIDATES = gql`
  query GetEligibleAgencyCandidates($userId: uuid!) {
    artist_users(
      where: {
        artist: { billing_user_id: { _eq: $userId } }
        user: {
          master_account_id: { _is_null: true }
          id: { _neq: $userId }
        }
      }
      distinct_on: user_id
    ) {
      user {
        id
        email
        first_name
        last_name
      }
    }
  }
`;

export const M_ADD_AGENCY_MEMBER = gql`
  mutation AddAgencyMember($user_id: String!) {
    add_agency_member(user_id: $user_id) {
      success
    }
  }
`;

export const M_REMOVE_AGENCY_MEMBER = gql`
  mutation RemoveAgencyMember($user_id: String!) {
    remove_agency_member(user_id: $user_id) {
      success
    }
  }
`;
